import * as React from "react";
import './UnderBoxToLogin.pcss';

export const UnderBoxToLogin = (props:{hideSignInLink:boolean}) =>
  <div className="under-box-container">
    <div className="under-box">
      {!props.hideSignInLink &&
        <div className={"go-to-login"}>
          <span>Already have an account?</span>
          <a href="/">Go to sign in</a>
        </div>
      }
    </div>
  </div>
;
